/* ===== Lab Essensia — theme.js ===== */
(function(){
  /* scroll reveal */
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target); } });
  }, { threshold:.12, rootMargin:'0px 0px -40px 0px' });
  function reveal(){ document.querySelectorAll('.rv:not(.in)').forEach(function(el){ io.observe(el); }); }
  reveal();

  /* mobile menu toggle */
  var toggle = document.querySelector('.nav-toggle');
  if(toggle){
    toggle.addEventListener('click', function(){
      var open = document.body.classList.toggle('menu-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    /* close menu when a link inside it is tapped */
    var mm = document.getElementById('mobileMenu');
    if(mm){
      mm.addEventListener('click', function(e){
        if(e.target.closest('a')){
          document.body.classList.remove('menu-open');
          toggle.setAttribute('aria-expanded','false');
        }
      });
    }
    /* close on resize to desktop */
    window.addEventListener('resize', function(){
      if(window.innerWidth > 900 && document.body.classList.contains('menu-open')){
        document.body.classList.remove('menu-open');
        toggle.setAttribute('aria-expanded','false');
      }
    });
  }

  /* product gallery */
  document.addEventListener('click', function(e){
    var th = e.target.closest('.thumb');
    if(th){
      var main = document.getElementById('mainImg');
      if(main){ main.src = th.getAttribute('data-full'); }
      document.querySelectorAll('.thumb').forEach(function(t){ t.classList.remove('on'); });
      th.classList.add('on');
    }
  });

  /* qty stepper */
  document.addEventListener('click', function(e){
    var b = e.target.closest('[data-step]');
    if(!b) return;
    var input = document.getElementById('qty');
    if(!input) return;
    var v = parseInt(input.value,10) || 1;
    v += parseInt(b.getAttribute('data-step'),10);
    if(v < 1) v = 1;
    input.value = v;
  });

  /* faq accordion */
  document.addEventListener('click', function(e){
    var head = e.target.closest('.q-head');
    if(!head) return;
    var q = head.parentElement, body = q.querySelector('.q-body');
    if(q.classList.contains('open')){ q.classList.remove('open'); body.style.maxHeight = null; }
    else { q.classList.add('open'); body.style.maxHeight = body.scrollHeight + 'px'; }
  });

  /* toast */
  function toast(msg){
    var t = document.getElementById('toast');
    if(!t){ return; }
    t.textContent = msg;
    t.classList.add('show');
    clearTimeout(window._tt);
    window._tt = setTimeout(function(){ t.classList.remove('show'); }, 2200);
  }

  /* variant change → update displayed price */
  var vsel = document.getElementById('variant-select');
  if(vsel){
    vsel.addEventListener('change', function(){
      var opt = vsel.options[vsel.selectedIndex];
      var p = opt ? opt.getAttribute('data-price') : null;
      if(p){
        var amt = document.getElementById('price-amt');
        if(amt){ amt.textContent = p; }
        var mbb = document.querySelector('.mbb-price');
        if(mbb){ mbb.textContent = p; }
      }
    });
  }

  /* AJAX add to cart + bubble update */
  var form = document.getElementById('product-form');
  if(form){
    form.addEventListener('submit', function(e){
      e.preventDefault();
      var btn = form.querySelector('.add');
      var orig = btn ? btn.textContent : '';
      if(btn){ btn.textContent = 'Adding…'; btn.disabled = true; }
      fetch('/cart/add.js', {
        method:'POST',
        headers:{'Content-Type':'application/json','Accept':'application/json'},
        body: JSON.stringify({
          id: form.querySelector('[name="id"]').value,
          quantity: parseInt((document.getElementById('qty')||{value:1}).value,10) || 1
        })
      })
      .then(function(r){ return r.json(); })
      .then(function(){ return fetch('/cart.js').then(function(r){return r.json();}); })
      .then(function(cart){
        var c = document.getElementById('bagCount');
        if(c){ c.textContent = cart.item_count; }
        toast('Added to bag');
        if(btn){ btn.textContent = orig; btn.disabled = false; }
      })
      .catch(function(){
        if(btn){ btn.textContent = orig; btn.disabled = false; }
        form.submit();
      });
    });
  }
})();
